var map = {
	"./ALLERGEN_1.png": 8207,
	"./ALLERGEN_10.png": 7609,
	"./ALLERGEN_11.png": 7202,
	"./ALLERGEN_12.png": 3409,
	"./ALLERGEN_13.png": 5786,
	"./ALLERGEN_14.png": 3099,
	"./ALLERGEN_2.png": 5636,
	"./ALLERGEN_3.png": 2852,
	"./ALLERGEN_4.png": 7648,
	"./ALLERGEN_5.png": 539,
	"./ALLERGEN_6.png": 6870,
	"./ALLERGEN_7.png": 9866,
	"./ALLERGEN_8.png": 2863,
	"./ALLERGEN_9.png": 5115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5403;